"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "atessa": {
    "75f597a0": [{
      "hkey": "1f89907b",
      "slug": "montemarcone-colle-delle-pietre",
      "name": "Montemarcone-Colle delle Pietre",
      "primary": true,
      "skipSearch": false
    }],
    "montemarcone": [{
      "hkey": "1f89907b",
      "slug": "montemarcone-colle-delle-pietre",
      "name": "Montemarcone-Colle delle Pietre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cb615a49": [{
      "hkey": "5d543303",
      "slug": "piazzano-piana-la-fara",
      "name": "Piazzano-Piana la Fara",
      "primary": true,
      "skipSearch": false
    }],
    "piazzano": [{
      "hkey": "5d543303",
      "slug": "piazzano-piana-la-fara",
      "name": "Piazzano-Piana la Fara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;